import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInfoCircle24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M13 6.5v2h-2v-2zM13 17.5v-7h-2v7z" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconInfoCircle24);
export default ForwardRef;
